import * as React from 'react';

import AddSceneCommandLink from './AddSceneCommandLink';

import CharacterIcon from '../../../../shared/icons/CharacterIcon';

import {colors} from '../../../../../styles/variables';

interface Props {
  onPress: () => void;
}

const AddCharacterSceneCommandLink: React.FunctionComponent<Props> = props => {
  const {onPress} = props;
  return (
    <AddSceneCommandLink title={'キャラ'} onPress={onPress}>
      <CharacterIcon color={colors.textColor} />
    </AddSceneCommandLink>
  );
};

export default React.memo(AddCharacterSceneCommandLink);
